import { arrayOf, bool, number, shape, string } from 'prop-types'

export const hitsType = {
  activeSubstances: arrayOf(string.isRequired),
  attributes: arrayOf(string.isRequired),
  descriptionShort: string,
  ean: string,
  master: bool.isRequired,
  masterID: string.isRequired,
  manufacturer: string.isRequired,
  marketplace: bool.isRequired,
  packSize: string.isRequired,
  pharmaForm: string,
  prescriptionMedicine: bool.isRequired,
  price: number.isRequired,
  productName: string.isRequired,
  pzn: string.isRequired,
  RPMultiplier: number.isRequired,
  RPStartDate: number.isRequired,
  RPEndDate: number.isRequired,
  stockStatusReason: string,
  topsellerCount: number,
  __queryID: string,
}

export const searchResultsType = {
  hits: arrayOf(shape(hitsType)).isRequired,
  page: number.isRequired,
  hitsPerPage: number.isRequired,
  index: string.isRequired,
  queryID: string.isRequired,
}
